// authService.js
import { msalInstance } from '../index';
import { loginRequest } from '../authConfig';
import secureStorage from './secureStorage';

export const userInfoKeys = [
  'userId',
  'userReason',
  'userAccount',
  'userName',
  'userLoginTime',
  'userDepartment',
  'userFunctionTree',
];

export const msalAuthService = {
  async login() {
    try {
      msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed', error);
    }
  },

  async logout() {
    try {
      // 清除所有 localStorage 中的使用者資訊
      Object.keys(localStorage).forEach((key) => {
        if (userInfoKeys.includes(key)) {
          secureStorage.removeItem(key);
        }
      });

      msalInstance.logoutRedirect({
        account: msalInstance.getActiveAccount(),
        postLogoutRedirectUri: '/logout',
      });
    } catch (error) {
      console.error('Logout failed', error);
    }
  },

  async getAccessToken() {
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: msalInstance.getActiveAccount(),
      });
      return response.accessToken;
    } catch (error) {
      // Handle errors or fallback to interactive login
      console.error('Token acquisition failed', error);
      return null;
    }
  },

  getAccount() {
    return msalInstance.getActiveAccount();
  },
};
